import styled from "styled-components"

const ImageSquare = styled.img`
  background-color: ${({ theme }) => theme.colors.greyDisabled};
  aspect-ratio: 1;
  border-radius: ${({ theme }) => theme.borders.softRadius};
  width: 100%;
  max-height: 600px;
  max-width: 600px;
`

export default ImageSquare
